import React from 'react';
import { CodigosReferencia, TiposDocumentoReferencia } from '../Comunes/Listas';

const PieDelDocumento = (props) => {
    return (
        <>
            <div className='row'>
                <div className='col-25'>
                    <input
                        type="checkbox" name='ImpServ' id='ImpServ'
                        checked={props.Gestor.ImpServ === 'S'}
                        onChange={props.Modificar}
                    />
                    <label style={{ marginLeft: '5px' }}> 10% Servicio</label>
                </div>
                <div className='col-25'>
                    <input
                        type="checkbox" name='CkDatosRef' id='CkDatosRef'
                        checked={props.Gestor.CkDatosRef === 'S'}
                        onChange={props.Modificar}
                        disabled={props.Gestor.TipoDocumento === '8'}
                    />
                    <label style={{ marginLeft: '5px' }}> Datos Referencia</label>
                </div>



            </div>
            <div className='row'>
                <div className='col-50'>
                    <span className="col-form-span">Nota </span>
                    <textarea id="Nota" name="Nota" autoComplete='off' rows={5} value={props.Gestor.Nota} onChange={props.Modificar}></textarea>
                </div>
                <div className='col-50'>
                    {props.Gestor.CkDatosRef === 'S' ? <>
                        <div className='row'>
                            <div className='col-25'>
                                <span className="col-form-span">Tipo Referencia </span>
                            </div>
                            <div className='col-75'>
                                <select id="TipoDocRef" name="TipoDocRef" className="form-group" onChange={props.Modificar} value={props.Gestor.TipoDocRef}>
                                    {TiposDocumentoReferencia.map((option, i) => (
                                        <option key={i} value={option.value}>{option.span}</option>
                                    ))}
                                </select>
                            </div>
                        </div>
                        <div className='row'>
                            <div className='col-25'>
                                <span className="col-form-span">Número Referencia </span>
                            </div>
                            <div className='col-75'>
                                <input autoComplete='off' type="text" id="NumeroRef" name='NumeroRef' onChange={props.Modificar} value={props.Gestor.NumeroRef} placeholder="Clave o Número del documento original" />
                            </div>
                        </div>
                        <div className='row'>
                            <div className='col-25'>
                                <span className="col-form-span">Fecha Referencia </span>
                            </div>
                            <div className='col-75'>
                                <input autoComplete='off' type="date" id="FechaEmisionRef" name='FechaEmisionRef' onChange={props.Modificar} value={props.Gestor.FechaEmisionRef} />
                            </div>
                        </div>
                        <div className='row'>
                            <div className='col-25'>
                                <span className="col-form-span">Código de referencia </span>
                            </div>
                            <div className='col-75'>
                                <select id="CodigoRef" name="CodigoRef" className="form-group" onChange={props.Modificar} value={props.Gestor.CodigoRef}>
                                    {CodigosReferencia.map((option, i) => (
                                        <option key={i} value={option.value}>{option.span}</option>
                                    ))}
                                </select>
                            </div>
                        </div>
                        <div className='row'>
                            <div className='col-25'>
                                <span className="col-form-span">Razón de Referencia </span>
                            </div>
                            <div className='col-75'>
                                <input autoComplete='off' type="text" id="RazonRef" name='RazonRef' onChange={props.Modificar} value={props.Gestor.RazonRef} placeholder="Razón por la que hace este documento" />
                            </div>
                        </div>
                    </> : null}
                </div>
            </div>
            {props.PerfilUsuario.IdCia === 1 || props.PerfilUsuario.IdCia === 383 ? (
                <div className='row'>
                    <div className='col-50'>
                        <div className='row'>
                            <div className='col-25'>
                                <span className="col-form-span">F. Producción </span>
                                <input type="date" id="Etiqueta1" name="Etiqueta1" autoComplete='off' value={props.Gestor.Etiqueta1} onChange={props.Modificar} />
                            </div>
                            <div className='col-25'>
                                <span className="col-form-span">F. Vencimiento </span>
                                <input type="date" id="Etiqueta2" name="Etiqueta2" autoComplete='off' value={props.Gestor.Etiqueta2} onChange={props.Modificar} />
                            </div>
                            <div className='col-50'>
                                <span className="col-form-span">Lote: </span>
                                <input type="text" id="CardFName" name="CardFName" autoComplete='off' value={props.Gestor.CardFName} onChange={props.Modificar} />
                            </div>
                        </div>
                    </div>
                    <div className='col-50'>

                    </div>
                </div>
            ) : null}
        </>
    );
};

export default PieDelDocumento;